import React, { useEffect, useState } from 'react'
import { KTSVG } from '../../_metronic/helpers';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { getValueFromResource, setItemStatus } from '../../common/timeLiveFunction';
import GoogleCalendar from '../../assets/image/Google.svg';
import OutlookCalendar from '../../assets/image/outlook.svg';
import fetchIntegrationAPI from '../../common/fetchIntegrationAPI';
import clsx from 'clsx';
import { Dropdown } from 'react-bootstrap';
import { getIntegrations, UpdateGoogleEventState, UpdateGoogleHolidayState, UpdateOutlookEventState, UpdateOutlookHolidayState } from './CalendarSlice';
import { ShowToast } from '../../common/Toastr';
import ColorDropdown from './ColorDropdown';

interface SettingstModalProps {
    t: any;
    onClose: () => void;
}
const { NODE_ENV } = process.env;
const CalendarSettings: React.FC<SettingstModalProps> = ({ t, onClose }) => {
    const { isLoading } = useAppSelector((state) => state.expensetype);
    const { integrationData, calendarStartDate, calendarEndDate } = useAppSelector((state) => state.calendar);
    const { AccountIntegrations, HolidayCalendars } = integrationData;
    const googleConnected = AccountIntegrations?.find((item: any) => item?.SystemIntegrationId.toLowerCase() === '3b00775f-9b50-4a7d-926f-1192e2e3033e');
    const outlookConnected = AccountIntegrations?.find((item: any) => item?.SystemIntegrationId.toLowerCase() === '6e0e6a9c-7a37-4bda-8d6a-d7d61f00b828');
    const dispatch = useAppDispatch();
    const [outlookCheckList, setOutlookCheckList] = useState<any[]>([]);
    const [googleCheckList, setGoogleCheckList] = useState<any[]>([]);
    const [googleLoading, setGoogleLoading] = useState(true);
    const [outlookLoading, setOutlookLoading] = useState(true);
    const [selectedGoogleHolidays, setSelectedGoogleHolidays] = useState<string[]>([]);
    const [selectedOutlookHolidays, setSelectedOutlookHolidays] = useState<string[]>([]);
    const [eventColor, setEventColors] = useState<any[]>([]);
    const [selectedColors, setSelectedColors] = useState<{ [key: string]: string }>({});
    const [selectedOutlookColors, setSelectedOutlookColors] = useState<{ [key: string]: string }>({});
    const AccountId = localStorage.getItem('accountId');
    const AccountEmployeeId = localStorage.getItem('accountEmployeeId');

    const getOutlookHolidays = async () => {
        try {
            const response = await fetchIntegrationAPI('api/OutlookCalendarAuth/GetOutlookHolidayCalendar', 'GET', "", true);
            const json = await response.json();
            setOutlookCheckList(json.Data || [])
        } catch (error) {
            console.log(error);
            setOutlookCheckList([]);
        } finally {
            setOutlookLoading(false)
        }
    }

    const getGoogleHolidays = async () => {
        try {
            setGoogleLoading(true);
            const response = await fetchIntegrationAPI('api/GoogleCalendarAuth/GetGoogleHolidayCalendar', 'GET', "", true);
            const json = await response.json();
            setGoogleCheckList(json.Data || []);
        } catch (error) {
            console.log(error);
            setGoogleCheckList([]);
        } finally {
            setGoogleLoading(false);
        }
    };

    const getGoogleColors = async () => {
        try {
            const response = await fetchIntegrationAPI('api/Calendar/GetCalendarEventColors', 'GET', "", true);
            const json = await response.json();
            setEventColors(json.Data || []);
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        getOutlookHolidays();
        getGoogleHolidays();
    }, []);

    useEffect(() => {
        if (Object.entries(googleConnected || {})?.length > 0 || Object.entries(outlookConnected || {})?.length > 0) {
            getGoogleColors();
        }
    }, [googleConnected, outlookConnected])

    useEffect(() => {
        const handleMessage = (event: any) => {
            if (NODE_ENV != 'development') {
                if (event.origin !== window.location.origin) return;
            }
            if (event.data.type === "AUTH_SUCCESS") {
                dispatch(getIntegrations());
                getOutlookHolidays();
                getGoogleHolidays();
                ShowToast('Success', event.data.payload.ResponseMessage, "success", "toast-top-right");
            }
            if (event.data.type === "AUTH_FAILED") {
                ShowToast('Error', event.data.payload, "error", "toast-top-right");
            }
            if (event.data.type === "AUTH_CANCELLED") {
                ShowToast('Info', event.data.payload, "info", "toast-top-right");
            }
            if (event.data.type === "AUTH_Empty") {
            }
        };
        window.addEventListener("message", handleMessage);
        return () => window.removeEventListener("message", handleMessage);
    }, []);

    const ConnectionButton = ({ btnName, BtnId }: any) => {
        const handleConnect = async () => {
            try {
                let response;
                if (BtnId === 'Google') {
                    response = await fetchIntegrationAPI(`api/GoogleCalendarAuth/initiate`, 'GET', "", true);
                } else if (BtnId === 'Outlook') {
                    response = await fetchIntegrationAPI(`api/OutlookCalendarAuth/initiate`, 'GET', "", true);
                }
                const json = await response?.json();
                const { authUrl } = json;
                if (authUrl) {
                    const width = 600;
                    const height = 700;
                    const left = (window.screen.width / 2) - (width / 2);
                    const top = (window.screen.height / 2) - (height / 2);

                    window.open(
                        authUrl,
                        BtnId,
                        `width=${width},height=${height},top=${top},left=${left},resizable=yes,scrollbars=yes,status=yes`
                    );
                }
            } catch (error) {
                console.log(error);
            }
        }
        return (
            <button className="btn btn-light-primary btn-sm mt-2" onClick={handleConnect}>
                {getValueFromResource(btnName, dispatch, t)}
            </button>
        )
    }

    const DisconnectButton = ({ data, btnName, btnId }: any) => {
        if (!data || Object.entries(data)?.length === 0) {
            return null;
        }

        const handleDelete = async (BtnId: any) => {
            try {
                let response;
                if (BtnId === 'Google') {
                    const { AccountIntegrationId } = googleConnected
                    response = await fetchIntegrationAPI(`api/AccountIntegration/${AccountIntegrationId}`, 'DELETE', "", true);
                    const json = await response.json();
                    if (json.StatusCode === '200') {
                        dispatch(getIntegrations());
                        dispatch(UpdateGoogleEventState([]));
                        ShowToast('Success', json.ResponseMessage, "success", "toast-top-right");
                    } else {
                        ShowToast('Error', json.ResponseMessage, "error", "toast-top-right");
                    }
                } else if (BtnId === 'Outlook') {
                    const { AccountIntegrationId } = outlookConnected
                    response = await fetchIntegrationAPI(`api/AccountIntegration/${AccountIntegrationId}`, 'DELETE', "", true);
                    const json = await response.json();
                    if (json.StatusCode === '200') {
                        ShowToast('Success', json.ResponseMessage, "success", "toast-top-right");
                        dispatch(getIntegrations());
                        dispatch(UpdateOutlookEventState([]));
                    } else {
                        ShowToast('Error', json.ResponseMessage, "error", "toast-top-right");
                    }
                }

            } catch (error) {
                console.log(error);
            }
        }
        return (
            <Dropdown
                className={clsx('cursor-pointer symbol')}
                align="end"
                style={{ marginTop: '7px' }}
            >
                <Dropdown.Toggle
                    variant="transparent"
                    className="btn btn-icon btn-active-light-dark btn-sm ms-0"
                    data-tooltip-id="tooltip-More"
                    data-tooltip-content={getValueFromResource('More', dispatch, t)}
                    data-tooltip-place="top"
                >
                    <i className="bi bi-three-dots-vertical fs-7"></i>
                </Dropdown.Toggle>

                <Dropdown.Menu className="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 px-1 py-1 fs-2 w-80px">
                    <Dropdown.Item
                        id="kt_OffCanvas"
                        className="menu-item me-lg-0 d-flex align-items-center py-1"
                        onClick={() => handleDelete(btnId)}
                    >
                        <span
                            className="menu-title custom-menu-fontsize"
                            style={{ marginLeft: '10px' }}
                        >
                            {getValueFromResource('Disconnect', dispatch, t)}
                        </span>
                    </Dropdown.Item>
                </Dropdown.Menu>
            </Dropdown>
        )
    };

    useEffect(() => {
        if (HolidayCalendars?.length) {
            setSelectedGoogleHolidays(HolidayCalendars.map((x: any) => x.HolidayCalendarName));
            setSelectedOutlookHolidays(HolidayCalendars.map((x: any) => x.HolidayCalendarName))
        }
    }, [HolidayCalendars]);

    const toggleGoogleHoliday = async (name: string, item: any) => {
        setSelectedGoogleHolidays((prev) => {
            const isAlreadySelected = prev.includes(name);
            if (isAlreadySelected) {
                deleteHoliday(item, 'google');
                dispatch(UpdateGoogleHolidayState([]))
                return prev.filter(x => x !== name);
            } else {
                addHoliday(item, 'google');
                return [...prev, name];
            }
        });
    };

    const toggleOutlookHoliday = (name: string, item: any) => {
        setSelectedOutlookHolidays((prev) => {
            const isAlreadySelected = prev.includes(name);
            if (isAlreadySelected) {
                deleteHoliday(item, 'outlook');
                dispatch(UpdateOutlookHolidayState([]));
                return prev.filter(x => x !== name);
            } else {
                addHoliday(item, 'outlook');
                return [...prev, name];
            }
        });
    };

    const addHoliday = async (item: any, source: string) => {
        const payload = {
            AccountIntegrationId: source === 'google'
                ? googleConnected?.AccountIntegrationId
                : outlookConnected?.AccountIntegrationId,
            CalendarTypeId: source === 'google' ? 2 : source === 'outlook' ? 3 : null,
            HolidayCalendarId: item?.HolidayCalendarId,
            HolidayCalendarName: item?.HolidayCalendarName,
        };

        try {
            let response = await fetchIntegrationAPI('api/HolidayCalendar', 'POST', payload, true);
            const json = await response?.json();
            if (json.StatusCode === '201') {
                dispatch(getIntegrations());
                ShowToast('Success', json.ResponseMessage, "success", "toast-top-right");
            } else {
                ShowToast('Error', json.ResponseMessage, "error", "toast-top-right");
            }
        } catch (err) {
            ShowToast('Error', err, "error", "toast-top-right");
        }
    };

    const deleteHoliday = async (item: any, source: string) => {
        const id = HolidayCalendars.find((i: any) => i?.HolidayCalendarId === item?.HolidayCalendarId)?.AccountHolidayCalendarId
        try {
            const response = await fetchIntegrationAPI(`api/HolidayCalendar/DeleteHolidayCalendar/${id}`, 'DELETE', "", true);
            const json = await response.json();
            if (json.StatusCode === '200') {
                ShowToast('Success', json.ResponseMessage, "success", "toast-top-right");
                dispatch(getIntegrations());
            } else {
                ShowToast('Error', json.ResponseMessage, "error", "toast-top-right");
            }
        } catch (err) {
            ShowToast('Error', err, "error", "toast-top-right");
        }
    };

    const handleUpdateColor = async (integrationId: any, color: string) => {
        try {
            const payload = {
                AccountEmployeeId,
                AccountId,
                AccountIntegrationId: String(integrationId),
                ColorCode: color
            }
            const response = await fetchIntegrationAPI('api/AccountIntegration/UpdateAccountIntegrationEventsColor', 'PUT', payload, true);
            await response.json();
            dispatch(getIntegrations());

        } catch (error) {
            ShowToast('Error', error, "error", "toast-top-right");
        }
        // onClose();
    }

    return (
        <div className="card-body">
            {isLoading ? (
                <div className="col-md-12 text-center">
                    <span className='spinner-border spinner-border-md'></span>
                </div>
            ) : (
                <div className="modal drawer-overlay" style={{ display: 'block' }}>
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header justify-content-between" style={{ padding: '.6rem .6rem' }}>
                                <h5 className="modal-title mainHeading">{getValueFromResource('Calendar Settings', dispatch, t)}</h5>
                                <div className="btn btn-icon btn-sm btn-active-secondary" onClick={onClose}>
                                    <KTSVG path="/media/icons/duotune/arrows/arr061.svg" className="svg-icon svg-icon-1x" />
                                </div>
                            </div>
                            <div className="modal-body">
                                <div className="d-flex justify-content-between align-items-start mt-3">
                                    <div className="d-flex gap-2">
                                        <img
                                            src={GoogleCalendar}
                                            alt="Google Calendar"
                                            width={40}
                                            height={40}
                                            style={{ border: '1px solid #eee', borderRadius: '4px' }}
                                        />
                                        <div className="d-flex gap-2" style={{ minWidth: '200px' }}>
                                            <div className='d-inline-flex align-items-center'>
                                                <span className="fw-semibold text-dark fs-3 ms-3">
                                                    Google Calendar
                                                </span>
                                                {Object.entries(googleConnected || {})?.length > 0 && (
                                                    <div className=' mt-2'>
                                                        <span
                                                            className="badge badge-sm badge-light-success ms-2 d-flex align-items-center justify-content-center"
                                                            style={{
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                lineHeight: 'normal',
                                                                height: '20px',
                                                                minWidth: '60px',
                                                                textAlign: 'center',
                                                                padding: '0 6px'
                                                            }}
                                                        >
                                                            Connected
                                                        </span>

                                                    </div>
                                                )}
                                            </div>

                                            {Object.entries(googleConnected || {})?.length > 0 && (
                                                <div className='' style={{ marginTop: '12px' }}>
                                                    <ColorDropdown
                                                        colors={eventColor}
                                                        selectedColor={selectedColors["google"]}
                                                        googleColor={googleConnected?.ColorCode}
                                                        onSelect={(color: any) => {
                                                            const googleIntegrationId = googleConnected?.AccountIntegrationId
                                                            handleUpdateColor(googleIntegrationId, color)
                                                            setSelectedColors((prev) => ({ ...prev, ["google"]: color }))
                                                        }}
                                                    />
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    <div>
                                        {Object.entries(googleConnected || {})?.length > 0 ? (
                                            <DisconnectButton data={googleConnected} btnName='Connect' btnId='Google' />
                                        ) : (
                                            <ConnectionButton btnName='Connect' BtnId='Google' />
                                        )}
                                    </div>
                                </div>

                                {Object.entries(googleConnected || {})?.length > 0 && (
                                    <>
                                        {googleLoading ? (
                                            <div className="col-md-12 text-center my-2">
                                                <span className="spinner-border spinner-border-sm"></span>
                                            </div>
                                        ) : (
                                            <div style={{ maxHeight: '150px', overflowY: 'auto', marginLeft: '55px' }}>
                                                {googleCheckList?.length > 0 && googleCheckList?.map((item: any, i: any) => (
                                                    <div key={i} className="d-flex gap-2">
                                                        <div className="form-check form-switch form-check-custom">
                                                            <input
                                                                id={`googleHoliday-${i}`}
                                                                className="form-check-input h-15px w-30px"
                                                                type="checkbox"
                                                                checked={selectedGoogleHolidays.includes(item?.HolidayCalendarName)}
                                                                onChange={() => toggleGoogleHoliday(item?.HolidayCalendarName, item)}
                                                            />
                                                        </div>
                                                        <label htmlFor={`googleHoliday-${i}`} className="text-dark d-block">
                                                            {item?.HolidayCalendarName}
                                                        </label>
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    </>
                                )}

                                <hr style={{ borderBottom: '1px solid #eee' }} />

                                <div className="d-flex justify-content-between align-items-start mt-3">
                                    <div className="d-flex gap-2">
                                        <img
                                            src={OutlookCalendar}
                                            alt="Outlook Calendar"
                                            width={40}
                                            height={40}
                                            style={{ border: '1px solid #eee', borderRadius: '4px' }}
                                        />
                                        <div className="d-flex gap-2" style={{ minWidth: '200px' }}>
                                            <div className='d-inline-flex align-items-center'>
                                                <span className="fw-semibold text-dark fs-3 ms-3">
                                                    Outlook Calendar
                                                </span>
                                                {Object.entries(outlookConnected || {})?.length > 0 && (
                                                    <div className=' mt-2'>
                                                        <span className="badge badge-sm badge-light-success ms-2 d-flex align-items-center justify-content-center">
                                                            Connected
                                                        </span>
                                                    </div>
                                                )}
                                            </div>
                                            {Object.entries(outlookConnected || {})?.length > 0 && (
                                                <div className='' style={{ marginTop: '12px' }}>
                                                    <ColorDropdown
                                                        colors={eventColor}
                                                        selectedColor={selectedOutlookColors["outlook"]}
                                                        googleColor={outlookConnected?.ColorCode}
                                                        onSelect={(color: any) => {
                                                            const outlookIntegrationId = outlookConnected?.AccountIntegrationId
                                                            handleUpdateColor(outlookIntegrationId, color)
                                                            setSelectedOutlookColors((prev) => ({ ...prev, ["outlook"]: color }))
                                                        }}
                                                    />
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    <div>
                                        {Object.entries(outlookConnected || {})?.length > 0 ? (
                                            <DisconnectButton data={outlookConnected} btnName='Connect' btnId='Outlook' />
                                        ) : (
                                            <ConnectionButton btnName='Connect' BtnId='Outlook' />
                                        )}
                                    </div>
                                </div>

                                {Object.entries(outlookConnected || {})?.length > 0 && (
                                    <>
                                        {outlookLoading ? (
                                            <div className="col-md-12 text-center my-2">
                                                <span className="spinner-border spinner-border-sm"></span>
                                            </div>
                                        ) : (

                                            <div style={{ maxHeight: '150px', overflowY: 'auto', marginLeft: '55px' }}>
                                                {outlookCheckList?.length > 0 && outlookCheckList?.map((item: any, i: any) => (
                                                    <div key={i} className="d-flex gap-2">
                                                        <div className="form-check form-switch form-check-custom">
                                                            <input
                                                                id={`outlookHoliday-${i}`}
                                                                className="form-check-input h-15px w-30px"
                                                                type="checkbox"
                                                                checked={selectedOutlookHolidays.includes(item?.HolidayCalendarName)}
                                                                onChange={() => toggleOutlookHoliday(item?.HolidayCalendarName, item)}
                                                            />
                                                        </div>
                                                        <label htmlFor={`outlookHoliday-${i}`} className="text-dark d-block">
                                                            {item?.HolidayCalendarName}
                                                        </label>
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    </>
                                )}

                            </div>
                            <div className="modal-footer">
                                <button className="btn btn-secondary btn-sm" onClick={onClose}>
                                    {getValueFromResource('Cancel', dispatch, t)}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}

export default CalendarSettings
